import moduleCapacity from "@/store/capacity/moduleCapacity.js";
import moduleSkills from "@/store/skills/moduleSkills.js";
import moduleTimeWindow from "@/store/time-window/moduleTimeWindow.js";
import moduleCommon from "@/store/common/moduleCommon.js";
import VisitPoint from "@/models/VisitPoint";
import Api from "@/helpers/api.js";
import pinMap from "@/assets/images/markers/visit_point.png";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import GoogleMap from "@/components/Maps/Maps.vue";
import AssignedSkillList from "@/components/skills/AssignedSkillList.vue";
import AssignedCapacityList from "@/components/capacity/AssignedCapacityList.vue";
import AssignedTimeWindowList from "@/components/time-window/list/AssignedTimeWindowList.vue";
import AssignedFrequencyList from "@/components/frequency/list/AssignedFrequencyList.vue";
import moduleMap from "@/store/map/moduleMap.js";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";
import FloatingButtons from "@/views/FloatingButtons.vue";

export const visitPointMixin = {
	name: "VisitPointCreate",
	mixins: [generalPurposeMixin],
	components: {
		vSelect,
		flatPickr,
		GoogleMap,
		AssignedSkillList,
		AssignedCapacityList,
		AssignedTimeWindowList,
		AssignedFrequencyList,
		FloatingButtons,
	},
	props: {
		data: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			departments: [],
			countries: [],
			cities: [],
			showMap: false,
			activePrompt: false,
			visitPoint: new VisitPoint({}),
			dataGeo: {},
			activeTab: 0,
			columnsCapacity: ["name", "description", "action"],
			defaultColumnsCapacity: ["name", "description"],
			hours: 0,
			minutes: 0,
			priority: 0,
			showPromptField: false,
			propertiesList: [],
			propertiesObject: {},
			isUpdate: false,
			indexUpdate: null,
			showGeoAgaing: false,
			dangerInput: {
				name: {show: false, text: ""},
				identification: {show: false, text: ""},
				address: {show: false, text: ""},
				city: {show: false, text: ""},
				country: {show: false, text: ""},
				phone: {show: false, text: ""},
				cy: {show: false, text: ""},
				cx: {show: false, text: ""},
			},
			configdateTimePicker: {
				enableSeconds: true,
				enableTime: true,
				noCalendar: true,
			},
			property: {
				label: "",
				value: "",
				type: {
					label: "Text",
					value: "text",
				},
			},
			type: [
				{
					label: "Text",
					value: "text",
				},
				{
					label: "Date",
					value: "date",
				},
				{
					label: "Time",
					value: "time",
				},
				{
					label: "Number",
					value: "number",
				},
			],
			skillListConfig: {
				rowSelection: "multiple",
				activeCheckbox: true,
				activeHeaderCheckboxSelection: true,
				activeLink: false,
				columns: ["id", "name", "description", "identifier", "action"],
				defaultColumns: ["id", "name", "description", "identifier"],
				tableOptions: false,
				showItemsPerPage: false,
				showSearch: false,
				showActions: false,
				navbarOptions: true,
			},
		};
	},
	computed: {
		countriesOptions() {
			return this.generateOptionSelect(this.$store.state.moduleCommon.countries, "country_name", "country_name");
		},
		validateForm() {
			return !this.errors.any();
		},
		validFormAdditionalFields() {
			return this.property.label.length > 0 && this.property.value.length > 0;
		},
		selectedCountry: {
			get() {
				return {
					label: this.visitPoint.country === undefined ? "" : this.visitPoint.country,
					value: this.visitPoint.country === undefined ? "" : this.visitPoint.country,
				};
			},
			set(obj) {
				this.selectedDepartment = {};
				this.selectedCity = {};
				this.visitPoint.country = obj.label;
				this.getDepartments(obj.label);
			},
		},
		selectedDepartment: {
			get() {
				return {
					label: this.visitPoint.department,
					value: this.visitPoint.department,
				};
			},
			set(obj) {
				this.selectedCity = {};
				this.visitPoint.department = obj.label;
				this.getCities(obj.label);
			},
		},
		selectedCity: {
			get() {
				return {
					label: this.visitPoint.city,
					value: this.visitPoint.city,
				};
			},
			set(obj) {
				if (Object.entries(obj).length > 0) {
					this.visitPoint.city = obj.label;
					this.geoCoder();
				}
			},
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		geoCoder() {
			const {country, city, address, department} = this.visitPoint;
			if (address === null || address === undefined || address === "") {
				this.$vs.notify({
					color: "warning",
					title: this.$t("VisitPoints.MissingAddress.Title"),
					text: this.$t("VisitPoints.MissingAddress.Text"),
				});
				return;
			}
			this.openLoading();
			this.$store
				.dispatch("moduleMap/geocoder", {country, city, address, department})
				.then((res) => {
					this.closeLoading();
					if (res.status !== 200) {
						throw new Error("Not georreferencer address");
					}
					if (res.status === 200 && res.message === "Procesado y no ubicado.") {
						this.activePrompt = false;
						this.$vs.notify({
							color: "warning",
							title: this.$t("VisitPoints.Georeferencer"),
							text: this.$t("VisitPoints.AddressCouldBeNotGeoreferenced"),
						});
						return;
					}

					if (res.status === 200) {
						this.dataGeo = {...res.data};
						this.visitPoint.cy = parseFloat(this.dataGeo.latitude);
						this.visitPoint.cx = parseFloat(this.dataGeo.longitude);
						if (this.dataGeo.latitude !== "0" || this.dataGeo.longitude !== "0") {
							Anuket.clearMap();
							this.$vs.notify({
								color: "success",
								title: this.$t("VisitPoints.FindAddress.Title"),
								text: this.$t("VisitPoints.FindAddress.Text"),
							});
							this.showGeoAgaing = true;
							this.$refs.moduleMap.addMarkerVisitPoint(this.visitPoint, false, "upload", pinMap, true);
						} else {
							this.$vs.notify({
								color: "warning",
								title: this.$t("VisitPoints.ErrorFindAddress.Title"),
								text: this.$t("VisitPoints.ErrorFindAddress.Text"),
							});
						}
					}
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.processError(err);
					console.error(err);
				});
		},
		geoInverso({cy, cx}) {
			this.openLoading();
			this.$store
				.dispatch("moduleMap/geoinverso", {cy, cx})
				.then((res) => {
					this.closeLoading();
					this.dataGeo = {...res.data};
					this.dataGeo.longitude = parseFloat(cx);
					this.dataGeo.latitude = parseFloat(cy);
					if (res.data.address1 !== this.visitPoint.address) {
						this.activePrompt = true;
					}
					if (res.status === 200 && res.data.status === "C") {
						this.activePrompt = false;
						this.$vs.notify({
							color: "warning",
							title: this.$t("VisitPoints.ErrorFindAddress.Title"),
							text:
								this.$t("VisitPoints.ErrorFindAddress.Text") +
								", " +
								this.$t("VisitPoints.ErrorFindCountry.Text"),
							time: 7000,
						});
					}
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.processError(err);
					console.error(err);
				});
		},
		acceptAlert() {
			this.selectedCountry.label = this.dataGeo.country_long_name;
			this.visitPoint.country = this.dataGeo.country_long_name;
			this.visitPoint.address = this.dataGeo.address1;
			this.selectedDepartment.label = this.dataGeo.department1;
			this.selectedCity.label = this.dataGeo.city1;
			this.visitPoint.department = this.dataGeo.department1;
			this.visitPoint.city = this.dataGeo.city1;
			this.visitPoint.cx = parseFloat(this.dataGeo.longitude.toFixed(8));
			this.visitPoint.cy = parseFloat(this.dataGeo.latitude.toFixed(8));
		},
		close() {
			this.dataGeo.address1 = "";
			this.geoCoder();
		},
		generateOptionSelect(data, propLabel, propValue) {
			if (!Array.isArray(data)) {
				return [];
			}
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		save_changes() {
			if (!this.validateForm) return;
			this.$validator.validateAll().then((result) => {
				if (result) {
					if (!this.validateForm) return;
					this.registerVisitPoint();
				} else {
					this.$vs.notify({
						color: "danger",
						title: this.$t("VisitPoints.ValidData.Title"),
						text: this.$t("VisitPoints.ValidData.Text"),
						time: 6000,
					});
					this.activeTab = 0;
				}
			});
		},
		registerVisitPoint() {
			delete this.visitPoint.id;
			const ids_skill = this.$store.state.moduleSkills.listSelectedSkills.map(({id}) => id);
			const ids_time_window = this.$store.state.moduleTimeWindow.assignedTimeWindows.map(({id}) => id);
			this.visitPoint["capacities"] = this.$store.state.moduleCapacity.listSelectedCapacities.map((capacity) => {
				let jobType;
				if (capacity.typeService === "DELIVERY") {
					jobType = "DELIVERY";
				} else if (capacity.typeService === "PICKUP") {
					jobType = "PICKUP";
				} else if (capacity.typeService === this.$t("DELIVERY")) {
					jobType = "DELIVERY";
				} else if (capacity.typeService === this.$t("PICKUP")) {
					jobType = "PICKUP";
				} else {
					jobType = capacity.typeService.value;
				}
				return {
					capacity_id: capacity.id,
					amount: parseInt(capacity.demand),
					job_type: jobType,
				};
			});
			this.visitPoint["skills_id"] = ids_skill || [];
			this.visitPoint["time_window_id"] = ids_time_window || [];
			this.visitPoint["repeat_frequency_id"] =
				this.$store.state.frequency.assignedFrequencies.map(({id}) => id) || [];
			this.visitPoint["additional_info"] = this.propertiesObject || {};
			this.visitPoint["json_properties"] = this.propertiesList || [];
			this.visitPoint["time_service"] = `${this.hours < 10 ? "0" + this.hours : this.hours}:${
				this.minutes < 10 ? "0" + this.minutes : this.minutes
			}:00`;
			this.visitPoint["priority"] = parseInt(this.visitPoint["priority"]);
			this.$store
				.dispatch("moduleVisitPoint/save", this.visitPoint)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("VisitPoints.Success.Title"),
						text: this.$t("VisitPoints.Success.Text"),
					});
					this.visitPoint = new VisitPoint({});
					this.$router.push({name: "app-visit-point-list"});
				})
				.catch((error) => {
					console.warn(error);
					this.validateErrorRegister(error);
				});
		},
		validateErrorRegister(error) {
			if (error.data === null || error.data === undefined) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("VisitPoints.ErrorRegisterValidate.Title"),
					text: this.$t("VisitPoints.ErrorRegisterValidate.Text"),
				});
				return;
			}
			if (error.data.reason.length > 0) {
				let reason = Array.from(new Set(error.data.reason.flatMap(({absolute_path}) => absolute_path)));
				let reasonFiltered = reason
					.filter((m) => m !== "additional_info")
					.map((m) => `${m.toUpperCase()}: ${this.$t("Routing.Messages.ValidatorRequiredProperty")} `)
					.join("; ");
				this.$vs.notify({
					color: "danger",
					title: this.$t("VisitPoints.ErrorRegisterValidate.Title"),
					text: reasonFiltered,
					time: 6000,
				});
			}
		},
		getCities(departmentName) {
			Api.post("/divipola", {
				country: this.visitPoint.country,
				department: departmentName ? departmentName.replaceAll(",", "") : "",
				city: "",
				world_code: "",
				only: "city_name",
				fields: ["city_name"],
			})
				.then((res) => {
					this.cities = this.generateOptionSelect(res.data, "city_name", "city_name");
				})
				.catch((e) => {
					console.error("❌ Error Getting Cities", e);
				});
		},
		getDepartments(countryName) {
			Api.post("/divipola", {
				country: countryName,
				department: "",
				city: "",
				world_code: "",
				only: "department_name",
				fields: ["department_name"],
			})
				.then((res) => {
					this.departments = this.generateOptionSelect(res.data, "department_name", "department_name");
				})
				.catch((e) => {
					console.error("❌ Error Getting Department name", e);
				});
		},
		addProperty(property) {
			let findOther = this.propertiesList.findIndex((elem) => elem.label === property.label);
			if (findOther == -1) {
				this.propertiesList.push(property);
				this.propertiesObject[property.label] = property.value;
				this.property = {
					label: "",
					type: {
						label: "Text",
						value: "text",
					},
					value: "",
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else if (this.isUpdate) {
				this.updateProperty(property);
				this.property = {
					label: "",
					type: {
						label: "Text",
						value: "text",
					},
					value: "",
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Alert"),
					text: this.$t("ResourceModule.Messages.AddProperties.Error.Text2"),
				});
			}
		},
		deleteItem(data, indexItem) {
			this.propertiesList.splice(indexItem, 1);
			delete this.propertiesObject[data.label];
		},
		editSelect(val, index) {
			this.isUpdate = true;
			this.showPromptField = true;
			this.property.label = val.label;
			this.property.value = val.value;
			this.property.type = val.type;
			this.indexUpdate = index;
		},
		updateProperty(property) {
			this.propertiesList[this.indexUpdate].label = property.label;
			this.propertiesList[this.indexUpdate].value = property.value;
			this.propertiesList[this.indexUpdate].type = property.type;
			this.propertiesObject[property.label] = property.value;
		},
		showPrompt() {
			this.showPromptField = true;
			this.isUpdate = false;
			this.property = {
				label: "",
				value: "",
				type: {
					label: "Text",
					value: "text",
				},
			};
		},
		validateKeyAdditionalInfo(event) {
			let regex = /^[a-zA-Z_]\w*$/;
			let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumber(event) {
			if (this.hours.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberMinutes(event) {
			if (this.minutes.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberPriority(event) {
			if (this.hours.length === 3) {
				event.preventDefault();
				return false;
			}
		},
		validateDateHours() {
			if (this.hours === "" || this.hours === null) this.hours = 0;
		},
		validateDateMinutes() {
			if (this.minutes === "" || this.minutes === null) this.minutes = 0;
		},
		validateDatePriority() {
			if (this.visitPoint.priority === "" || this.visitPoint.priority === null) this.visitPoint.priority = 0;
		},
	},
	watch: {
		activeTab(val) {
			if (val === 0) {
				setTimeout(() => {
					if (this.visitPoint.cx !== 0 && this.visitPoint.cy !== 0)
						this.$refs.moduleMap.addMarkerVisitPoint(this.visitPoint, false, "upload", pinMap, true);
				}, 1000);
			}
		},
		hours(val) {
			if (val > 23) {
				this.hours = 23;
			}
		},
		minutes(val) {
			if (val > 59) {
				this.minutes = 59;
			}
		},
		"visitPoint.priority"(val) {
			if (val > 100) {
				this.visitPoint.priority = 100;
			}
		},
		"visitPoint.address"(valOld, valNew) {
			if (
				valOld != valNew &&
				this.visitPoint.country != "" &&
				this.visitPoint.city != "" &&
				this.visitPoint.department != ""
			) {
				this.showGeoAgaing = true;
			} else {
				this.showGeoAgaing = false;
			}
		},
	},
	created() {
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		if (!moduleCapacity.isRegistered) {
			this.$store.registerModule("moduleCapacity", moduleCapacity);
			moduleCapacity.isRegistered = true;
		}
		if (!moduleSkills.isRegistered) {
			this.$store.registerModule("moduleSkills", moduleSkills);
			moduleSkills.isRegistered = true;
		}
		if (!moduleTimeWindow.isRegistered) {
			this.$store.registerModule("moduleTimeWindow", moduleTimeWindow);
			moduleTimeWindow.isRegistered = true;
		}
		if (!moduleMap.isRegistered) {
			this.$store.registerModule("moduleMap", moduleMap);
			moduleMap.isRegistered = true;
		}
		if (this.$store.state.moduleCommon.countries.length <= 0) {
			this.$store
				.dispatch("moduleCommon/getCountries")
				.then((res) => {
					if (res.data.length === 1) {
						this.selectedCountry = {
							label: res.data[0]["country_name"].toUpperCase(),
							value: res.data[0]["country_name"].toUpperCase(),
						};
					}
				})
				.catch((error) => {
					console.error(error);
				});
		}
	},
	mounted() {
		this.showMap = true;
	},
	beforeDestroy() {
		this.showGeoAgaing = false;
		this.$store.commit("moduleCapacity/REMOVE_ALL_ASSIGNED_CAPACITY");
		this.$store.commit("moduleSkills/REMOVE_ALL_ASSIGNED_SKILL");
		this.$store.commit("moduleTimeWindow/REMOVE_ALL_ASSIGNED_TIME_WINDOW");
		this.$store.commit("frequency/REMOVE_ALL_ASSIGNED_FREQUENCY");
	},
};
